const ignoredHosts = ['translate.googleusercontent.com'];

const isIgnoredHosts = host => ignoredHosts.includes(host);
export { isIgnoredHosts };
